module.exports = "@import 'https://bib-adsengine.com/static/css/cdn.css';"